import { OnwardCheckbox } from '@/components/ShipmentForm/blocks';
import { colors, typography } from '@/styles';
import { CircularProgress, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useState } from 'react';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';

const getOptionLabel = (order) => {
    return [order?.order_number, order?.po_number, order?.reference_id].filter((x) => !!x).join(' / ');
};

export const AsyncOrderAutocomplete = ({ label, placeholder, options, loading, onChange, value, onSearch }) => {
    const [debouncer, setDebouncer] = useState(null);

    return (
        <Autocomplete
            fullWidth
            freeSolo
            value={value || ''}
            onInputChange={(e, value) => {
                if (debouncer) {
                    clearTimeout(debouncer);
                }
                setDebouncer(
                    setTimeout(() => {
                        onSearch(value);
                    }, 500)
                );
            }}
            onChange={(e, value) => {
                const next = options[value];
                onChange(!!next ? next : null);
            }}
            noOptionsText="No orders found"
            options={Object.keys(options)}
            loading={loading}
            getOptionSelected={(option, value) => {
                return option === value;
            }}
            getOptionLabel={(option) => getOptionLabel(options[option])}
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        variant="outlined"
                        label={label}
                        placeholder={placeholder}
                        error={!value}
                        InputProps={{
                            ...(params.InputProps || {}),
                            endAdornment: (
                                <>
                                    {loading ? (
                                        <CircularProgress
                                            css={css`
                                                color: ${colors.greens.primary};
                                            `}
                                            size={20}
                                        />
                                    ) : null}
                                    {params.InputProps?.endAdornment}
                                </>
                            ),
                        }}
                    />
                );
            }}
            renderOption={(option) => (
                <Grid item>
                    <OnwardCheckbox checked={option === value} />
                    <span
                        css={css`
                            ${typography.sansSerif}
                        `}
                    >
                        {getOptionLabel(options[option])}
                    </span>
                </Grid>
            )}
        />
    );
};
